import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        // {
        //   path: '*',
        //   redirect: '/'
        // },
        {
            path: "/",
            name: "newpage/pageList",
            component: () => import("./views/newpage/pageList"),
        },
        {
            path: "/newpage/pageList",
            name: "newpage/pageList",
            component: () => import("./views/newpage/pageList"), //新口子页面
        },
        {
            path: "/newpage/pageListNew",
            name: "newpage/pageListNew",
            component: () => import("./views/newpage/pageListNew"), //新口子页面马甲包
        },
        {
            path: "/newpage/activePage",
            name: "newpage/activePage",
            component: () => import("./views/newpage/activePage"), //活动页面
        },
        {
            path: "/newpage/pageListOld",
            name: "newpage/pageListOld",
            component: () => import("./views/newpage/pageListOld"), //新口子页面
        },
        {
            path: "/newpage/productDetail",
            name: "newpage/productDetail",
            component: () => import("./views/newpage/productDetail"), //产品详情
        },
        {
            path: "/newpage/pageListPage",
            name: "newpage/pageListPage",
            component: () => import("./views/newpage/pageListPage"),
        },
        {
            path: "/newpage/hello",
            name: "newpage/hello",
            component: () => import("./views/newpage/hello"),
        },
        {
            path: "/agree/privacyAgree", //隐私协议
            name: "agree/privacyAgree",
            component: () => import("./views/agree/privacyAgree"),
        },
        {
            path: "/agree/helpCenter", //帮助中心
            name: "agree/helpCenter",
            component: () => import("./views/agree/helpCenter"),
        },
        {
            path: "/vip/success",
            name: "vip/success",
            component: () => import("./views/vip/success"), //支付成功
        },
        {
            path: "/vip/notice",
            name: "vip/notice",
            component: () => import("./views/vip/notice"), //在线客服
        },
        {
            path: "/vip/test",
            name: "vip/test",
            component: () => import("./views/vip/test"), //支付成功
        },
        {
            path: "/vip/goldCoinDown",
            name: "vip/goldCoinDown",
            component: () => import("./views/vip/goldCoinDown"), //金币掉落
        },
        {
            path: "/vip/luckDraw",
            name: "vip/luckDraw",
            component: () => import("./views/vip/luckDraw"), //抽奖
        },
        {
            path: "/vip/creditCheck",
            name: "vip/creditCheck",
            component: () => import("./views/vip/creditCheck"), //vip检测页面
        },
        {
            path: "/vip/checkList",
            name: "vip/checkList",
            component: () => import("./views/vip/checkList"), //vip检测报告
        },
        {
            path: "/vip/vipDetail",
            name: "vip/vipDetail",
            component: () => import("./views/vip/vipDetail"), //vip检测报告
        },
        {
            path: "/vip/agreement",
            name: "vip/agreement",
            component: () => import("./views/vip/agreement"), //协议
        },
        {
            path: "/vip/handleVip",
            name: "vip/handleVip",
            component: () => import("./views/vip/handleVip"), //vip首页
        },
        {
            path: "/vip/newHandleVip",
            name: "vip/newHandleVip",
            component: () => import("./views/vip/newHandleVip"), //新vip首页
        },
        {
            path: "/vip/checkPage",
            name: "vip/checkPage",
            component: () => import("./views/vip/checkPage"), //校验页面
        },
        {
            path: "/vip/checkPageVip",
            name: "vip/checkPageVip",
            component: () => import("./views/vip/checkPageVip"), //校验页面-vip
        },
        {
            path: "/vip/checkPageVip1",
            name: "vip/checkPageVip1",
            component: () => import("./views/vip/checkPageVip1"), //校验页面-vip
        },
        {
            path: "/vip/choicePackage",
            name: "vip/choicePackage",
            component: () => import("./views/vip/choicePackage"), //vip选择套餐
        },
        {
            path: "/vip/applyWithDral",
            name: "vip/applyWithDral",
            component: () => import("./views/vip/applyWithDral"), //vip选择套餐
        },
        {
            path: "/vip/withDralSucc",
            name: "vip/withDralSucc",
            component: () => import("./views/vip/withDralSucc"), //vip选择套餐
        },
        {
            path: "/vip/equityDetail",
            name: "vip/equityDetail",
            component: () => import("./views/vip/equityDetail"), //vip权益详情页面
        },
        {
            path: "/vipActive/myCard",
            name: "vipActive/myCard",
            component: () => import("./views/vipActive/myCard"), //我的卡券
        },
        {
            path: "/vipActive/cardPage",
            name: "vipActive/cardPage",
            component: () => import("./views/vipActive/cardPage"), //我的卡券列表
        },
        {
            path: "/vipActive/myPrize",
            name: "vipActive/myPrize",
            component: () => import("./views/vipActive/myPrize"), //我的卡券
        },
        {
            path: "/vipActive/bagDetail",
            name: "vipActive/bagDetail",
            component: () => import("./views/vipActive/bagDetail"), //礼包详情
        },
        {
            path: "/vipActive/coinsDetail",
            name: "vipActive/coinsDetail",
            component: () => import("./views/vipActive/coinsDetail"), //金币明细
        },
        {
            path: "/vipActive/highList",
            name: "vipActive/highList",
            component: () => import("./views/vipActive/highList"), //优质口子
        },
        {
            path: "/vipActive/coinsShop",
            name: "vipActive/coinsShop",
            component: () => import("./views/vipActive/coinsShop"), //金币商城
        },
        {
            path: "/vipActive/signPage",
            name: "vipActive/signPage",
            component: () => import("./views/vipActive/signPage"), //签到领金币
        },
        {
            path: "/vipActive/waitCoinsList",
            name: "vipActive/waitCoinsList",
            component: () => import("./views/vipActive/waitCoinsList"), //待领取金币
        },
        {
            path: "/vipActive/couponDetail",
            name: "vipActive/couponDetail",
            component: () => import("./views/vipActive/couponDetail"), //券详情
        },
        {
            path: "/vipActive/couponDetailList",
            name: "vipActive/couponDetailList",
            component: () => import("./views/vipActive/couponDetailList"), //券详情-可兑换
        },
        {
            path: "/loan/applyStatus",
            name: "loan/applyStatus",
            component: () => import("./views/loan/applyStatus"), //支付成功
        },
        {
            path: "/loan/myDetail",
            name: "loan/myDetail",
            component: () => import("./views/loan/myDetail"), //查看详情
        },
        {
            path: "/loan/activeRepe",
            name: "loan/activeRepe",
            component: () => import("./views/loan/activeRepe"), //支付成功
        },
        {
            path: "/loan/applyDetail",
            name: "loan/applyDetail",
            component: () => import("./views/loan/applyDetail"), //支付成功
        },
        {
            path: "/loan/applySuccess",
            name: "loan/applySuccess",
            component: () => import("./views/loan/applySuccess"), //支付成功
        },
        {
            path: "/loan/bindBank",
            name: "loan/bindBank",
            component: () => import("./views/loan/bindBank"), //支付成功
        },
        {
            path: "/loan/bindCreditBank",
            name: "loan/bindCreditBank",
            component: () => import("./views/loan/bindCreditBank"), //信用卡
        },
        {
            path: "/loan/loanMoney",
            name: "loan/loanMoney",
            component: () => import("./views/loan/loanMoney"), //支付成功
        },
        {
            path: "/loan/signing",
            name: "loan/signing",
            component: () => import("./views/loan/signing"), //易美福——签约页面
        },
        {
            path: "/loan/repeDetail",
            name: "loan/repeDetail",
            component: () => import("./views/loan/repeDetail"), //支付成功
        },

        {
            path: "/vip/bindBank",
            name: "vip/bindBank",
            component: () => import("./views/vip/bindBank"), //支付成功
        },
        {
            path: "/vip/balanceRecord",
            name: "vip/balanceRecord",
            component: () => import("./views/vip/balanceRecord"), //支付成功
        },
        {
            path: "/vip/myBag",
            name: "vip/myBag",
            component: () => import("./views/vip/myBag"), //支付成功
        },
        {
            path: "/marquee",
            name: "marquee",
            component: () => import("./components/marquee"), //动态滚动跑马灯
        },
        {
            path: "/echarts",
            name: "echarts",
            component: () => import("./components/echarts"), //饼图
        },
        {
            path: "/afterLoan/phoneAuth",
            name: "afterLoan/phoneAuth",
            component: () => import("./views/afterLoan/phoneAuth"), //手机号认证
        },
        {
            path: "/afterLoan/applyNatural",
            name: "afterLoan/applyNatural",
            component: () => import("./views/afterLoan/applyNatural"), //资质不符
        },
        {
            path: "/afterLoan/authSuccess",
            name: "afterLoan/authSuccess",
            component: () => import("./views/afterLoan/authSuccess"), //认证成功
        },
        {
            path: "/afterLoan/applySuccess",
            name: "afterLoan/applySuccess",
            component: () => import("./views/afterLoan/applySuccess"),
        },
        {
            path: "/afterLoan/newApplySuccess",
            name: "afterLoan/newApplySuccess",
            component: () => import("./views/afterLoan/newApplySuccess"),
        },
        {
            path: "/afterLoan/applyDetail",
            name: "afterLoan/applyDetail",
            component: () => import("./views/afterLoan/applyDetail"),
        },
        {
            path: "/afterLoan/loanMoney",
            name: "afterLoan/loanMoney",
            component: () => import("./views/afterLoan/loanMoney"),
        },
        {
            path: "/afterLoan/repaymentDetail",
            name: "afterLoan/repaymentDetail",
            component: () => import("./views/afterLoan/repaymentDetail"),
        },
        {
            path: "/afterLoan/sureRepayment",
            name: "afterLoan/sureRepayment",
            component: () => import("./views/afterLoan/sureRepayment"),
        },
        {
            path: "/afterLoan/bindBank",
            name: "afterLoan/bindBank",
            component: () => import("./views/afterLoan/bindBank"), //豆豆钱绑卡
        },
        {
            path: "/afterLoan/limitPage",
            name: "afterLoan/limitPage",
            component: () => import("./views/afterLoan/limitPage"),
        },
        {
            path: "/afterLoan/suportBank",
            name: "afterLoan/suportBank",
            component: () => import("./views/afterLoan/suportBank"),
        },
        {
            path: "/afterLoan1/success",
            name: "afterLoan1/success",
            component: () => import("./views/afterLoan1/success"),
        },
        {
            path: "/afterLoan1/loanMoney",
            name: "afterLoan1/loanMoney",
            component: () => import("./views/afterLoan1/loanMoney"),
        },
        {
            path: "/afterLoan1/repaymentDetail",
            name: "afterLoan1/repaymentDetail",
            component: () => import("./views/afterLoan1/repaymentDetail"),
        },
        {
            path: "/afterLoan1/limitPage",
            name: "afterLoan1/limitPage",
            component: () => import("./views/afterLoan1/limitPage"),
        },
        {
            path: "/information/helperPage",
            name: "information/helperPage",
            component: () => import("./views/information/helperPage"), //提额助手
        },
        {
            path: "/information/hotInformation",
            name: "information/hotInformation",
            component: () => import("./views/information/hotInformation"), //热点资讯
        },
        {
            path: "/information/informationDetail",
            name: "information/informationDetail",
            component: () => import("./views/information/informationDetail"), //资讯详情
        },
        {
            path: "/vip/vipExclusive",
            name: "vip/vipExclusive",
            component: () => import("./views/vip/vipExclusive"), //会员独享
        },
        {
            path: "/vip/assetsInfo",
            name: "vip/assetsInfo",
            component: () => import("./views/vip/assetsInfo"), //资产信息
        },
        {
            path: "/vip/new/assetsInfo",
            name: "vip/new/assetsInfo",
            component: () => import("./views/vip/newAssetsInfo"), //新的资产信息
        },
        {
            path: "/vip/new/assetsInfo30",
            name: "vip/new/assetsInfo30",
            component: () => import("./views/vip/newAssetsInfo30"), //新的资产信息30
        },
        {
            path: "/vip/new/assetsInfoYiXin",
            name: "vip/new/assetsInfoYiXin",
            component: () => import("./views/vip/newAssetsInfoYiXin"), //亿信机构资产信息
        }, {
            path: "/vip/realNameAuth",
            name: "vip/realNameAuth",
            component: () => import("./views/vip/realNameAuth"), //实名信息认证页面
        },
        {
            path: "/newpage/recommendPage",
            name: "newpage/recommendPage",
            component: () => import("./views/newpage/recommendPage"), //推荐贷款
        },
        {
            path: "/newpage/recommendPage2",
            name: "newpage/recommendPage2",
            component: () => import("./views/newpage/recommendPage2"), //推荐贷款2
        },
        {
            path: "/newpage/recommendPageNew",
            name: "newpage/recommendPageNew",
            component: () => import("./views/newpage/recommendPageNew"), //另一个推荐贷款
        },
        {
            path: "/newpage/recommendPageNoConfig",
            name: "newpage/recommendPageNoConfig",
            component: () => import("./views/newpage/recommendPageNoConfig"), //另一个推荐贷款
        },
        {
            path: "/agency/images",
            name: "/agency/images",
            component: () => import("./components/agencyImages"), //另一个推荐贷款
        },
        {
            path: "/afterLoan/bankInfo",
            name: "afterLoan/bankInfo",
            component: () => import("./views/afterLoan/bankInfo"),
        },
        {
            path: "/vip/bankInfoAuth",
            name: "vip/bankInfoAuth",
            component: () => import("./views/vip/bankInfoAuth"), //银行卡绑定选填认证
        },
        {
            path: "/newpage/applyResult",
            name: "newpage/applyResult",
            component: () => import("./views/newpage/applyResult"), //申请结果页面
        },
        {
            path: "/vip/shBankInfoAuth",
            name: "vip/shBankInfoAuth",
            component: () => import("./views/vip/shBankInfoAuth"), //授信四要素绑定
        },
        {
            path: "/vip/shFaceAuth",
            name: "vip/shFaceAuth",
            component: () => import("./views/vip/shFaceAuth"), //授信人脸识别
        },
        {
            path: "/tcHelp/userDetail",
            name: "tcHelp/userDetail",
            component: () => import("./views/tcHelp/userDetail"), //tcHelp的我的页面的查看详情链接
        },
        {
            path: "/tcHelp/message",
            name: "tcHelp/message",
            component: () => import("./views/tcHelp/message"), //tcHelp的消息通告页面
        }, {
            path: "/tcHelp/kefu",
            name: "tcHelp/kefu",
            component: () => import("./views/tcHelp/kefu"), //tcHelp的咨询与反馈页面
        }, {
            path: "/mixed/messages",
            name: "mixed/messages",
            component: () => import("./views/mixed/messages"), //联系记录
        }, {
            path: "/tcHelp/productDetail",
            name: "tcHelp/productDetail",
            component: () => import("./views/tcHelp/productDetail"), //tcHelp的产品详情
        }, {
            path: "/mixed/xyList",
            name: "mixed/xyList",
            component: () => import("./views/mixed/xyList"), //协议列表
        }, {
            path: "/loan/applyResult",
            name: "loan/applyResult",
            component: () => import("./views/loan/applyResult"), //成单之后的申请成功页面
        }, {
            path: "/loan/applyResultNx",
            name: "loan/applyResultNx",
            component: () => import("./views/loan/applyResultNx"), //诺享撞库成功之后的页面
        }, {
            path: "/loan/applyResultZk",
            name: "loan/applyResultZk",
            component: () => import("./views/loan/applyResultZk"), //机构撞库成功之后的页面
        }, {
            path: "/mixed/agencyXy",
            name: "mixed/agencyXy",
            component: () => import("./views/mixed/agencyXy"), //展业帮机构协议
        }, {
            path: "/loan/agreement",
            name: "loan/agreement",
            component: () => import("./views/loan/agreement"), //协议弹框
        }, {
            path: "/mixed/upload",
            name: "mixed/upload",
            component: () => import("./views/mixed/upload"), //下载
        }, {
            path: "/loan/applyResultForeign",
            name: "loan/applyResultForeign",
            component: () => import("./views/loan/applyResultForeign"), //对外机构，推单之后的跳转页面
        }, {
            path: "/loan/applyResultForeignZk",
            name: "loan/applyResultForeignZk",
            component: () => import("./views/loan/applyResultForeignZk"), //对外机构，撞库之后的跳转页面
        }, {
            path: "/authBook/authZyb",
            name: "authBook/authZyb",
            component: () => import("./views/authBook/authZyb"), //对外机构，展业帮授权书
        }, {
            path: "/authBook/authCch",
            name: "authBook/authCch",
            component: () => import("./views/authBook/authCch"), //下游机构村村花
        }, {
            path: "/authBook/agreement",
            name: "authBook/agreement",
            component: () => import("./views/authBook/agreement"), //对外机构，协议展示
        },

    ],
});
